export const privList = (state, rootState) => {
	return state.privList;
}

export const objPrivEdit = (state, rootState) => {
	return state.objPrivEdit;
}

export const runAdd = (state, rootState) => {
	return state.runAdd;
}
